import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import {
  Dialog,
  DialogContent,
  DialogTitle,
  Select,
  Typography,
  FormControl,
  InputLabel,
  MenuItem,
  DialogActions,
  Button,
  Grid,
  TextField,
  IconButton,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import "./style.css";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { getSchema } from "./utils";
import { Container } from "@mui/system";
import axiosInstance from "../../../../axios";
import { useDispatch } from "react-redux";
import { fetchSessionResources } from "../../../../redux/slices/session-management.slice";
import { CoPresentOutlined } from "@mui/icons-material";
import moment from "moment";
import { SessionAPI } from "../../../../utils/services/session-management";

const resourceTypes = {
  ASSIGNMENT: "ASSIGNMENT",
  RECORDING: "RECORDING",
  STUDY_MATERIAL: "STUDY MATERIAL",
  LINKS: "LINKS",
};

const EditResourcePopUp = ({
  sessionId,
  open,
  setEditResourceOpen,
  sessionResourcesPage,
  setEditResourceData,
  sessionResourcesLimit,
  editResourceData,
}) => {
  const [dueDate, setDueDate] = useState(
    moment(editResourceData?.dueDate).format("YYYY-MM-DD") || ""
  );
  const [resourceName, setResourceName] = useState(
    editResourceData?.resourceName || ""
  );
  const [resourceType, setResourceType] = useState(
    editResourceData?.resourceType || ""
  );
  const [resourceFile, setResourceFile] = useState(
    editResourceData?.resourceFile || ""
  );
  const [resourceLink, setResourceLink] = useState(
    editResourceData?.resourceLink || ""
  );
  const [isUploading, setIsUploading] = useState(false);

  const handleReset = () => {
    // reset();
    // setResourceTypeForDate("");

    setResourceFile(editResourceData?.resourceFile);
    setResourceName(editResourceData?.resourceName);
    setResourceType(editResourceData?.resourceType);
    setResourceLink(editResourceData?.resourceLink);
    setDueDate(moment(editResourceData?.dueDate).format("YYYY-MM-DD") || "");
  };

  const dispatch = useDispatch();

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    // const data = getValues();

    const reqBody = {
      resourceName: resourceName,
      resourceLink: resourceLink,
      resourceFile: resourceFile,
      ...(resourceType === resourceTypes?.ASSIGNMENT && { dueDate: dueDate }),
    };

    const { payload } = await SessionAPI.updateResource(
      editResourceData?.id,
      reqBody
    );

    if (payload) {
      setEditResourceOpen(false);

      dispatch(
        fetchSessionResources({
          sessionId,
          sessionResourcesLimit,
          sessionResourcesPage,
        })
      );
    }
  };

  const handleUploadFile = async ({ target }) => {
    const files = target.files[0];
    let formData = new FormData();
    formData.append("file", files);
    formData.append("module", "batch");
    let payload = formData;

    setIsUploading(true);
    try {
      const { data } = await axiosInstance.post(`/upload`, payload);

      if (data) {
        setResourceFile(data?.payload?.fileURL);
      }
      // error && handleError(error);
    } catch (e) {}
    setIsUploading(false);
  };

  const handleEditResourceLink = (e) => {
    setResourceLink(e.target.value);
  };

  const handleEditResourceName = (e) => {
    setResourceName(e?.target?.value);
  };

  const handleAssignmentDueDate = (e) => {
    setDueDate(moment(e.target.value).format("YYYY-MM-DD"));
  };

  const handleClose = () => {
    setEditResourceOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      className="add-resource-popup-container"
    >
      {isUploading && (
        <Backdrop sx={{ color: "#fff", zIndex: 1 }} open={isUploading}>
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <DialogTitle>
        <Typography variant="h6">Edit Resource</Typography>
        <IconButton
          sx={{
            position: "absolute",
            right: 8,
            top: 10,
            color: "black",
          }}
          onClick={() => handleClose()}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <form onSubmit={handleFormSubmit}>
        <DialogContent>
          {editResourceData != null && (
            <Grid
              container
              spacing={2}
              sx={{ marginTop: "0.5rem", marginBottom: "2rem" }}
            >
              <Grid item xs={12} sm={12} md={12}>
                <TextField
                  select
                  fullWidth
                  size="small"
                  label="Resource Type"
                  // value={getValues().resourceType}
                  // inputProps={register("resourceType")}
                  value={resourceType}
                  required
                  disabled
                  name="resourceType"
                >
                  <MenuItem key={1} value={resourceTypes?.RECORDING}>
                    Recording
                  </MenuItem>
                  <MenuItem key={2} value={resourceTypes?.STUDY_MATERIAL}>
                    Study Material
                  </MenuItem>
                  <MenuItem key={3} value={resourceTypes?.LINKS}>
                    Links
                  </MenuItem>
                  <MenuItem key={4} value={resourceTypes?.ASSIGNMENT}>
                    Assignment
                  </MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <TextField
                  label="Resource Name"
                  value={resourceName}
                  required
                  onChange={handleEditResourceName}
                  size="small"
                  fullWidth
                  name="resourceName"
                />
              </Grid>
              <Grid item xs={2} sm={2} md={2}>
                <Typography>Resource File:</Typography>
              </Grid>
              <Grid item xs={10} sm={10} md={10}>
                {resourceFile ? (
                  <div
                    style={{
                      border: "1px solid black",
                      borderRadius: "4px",
                      padding: "8px",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <p>
                      {resourceFile.length > 60
                        ? `${resourceFile.slice(0, 60)}...`
                        : resourceFile}
                    </p>
                    <div
                      onClick={() => setResourceFile("")}
                      style={{
                        cursor: "pointer",
                      }}
                    >
                      ⨯
                    </div>
                  </div>
                ) : (
                  <TextField
                    size="small"
                    type="file"
                    disabled={
                      !(
                        resourceType === resourceTypes?.ASSIGNMENT ||
                        resourceType === resourceTypes?.STUDY_MATERIAL ||
                        resourceType === resourceTypes?.RECORDING
                      )
                    }
                    helperText="Add Document or media"
                    onChange={handleUploadFile}
                    required
                    fullWidth
                  />
                )}
              </Grid>
              <Grid item xs={2} sm={2} md={2}>
                <Typography>Resource Link:</Typography>
              </Grid>
              <Grid item xs={10} sm={10} md={10}>
                <TextField
                  size="small"
                  label="Add Link"
                  value={resourceLink}
                  disabled={
                    resourceType === resourceTypes?.ASSIGNMENT ||
                    resourceType === resourceTypes?.STUDY_MATERIAL ||
                    resourceType === resourceTypes.RECORDING
                  }
                  onChange={handleEditResourceLink}
                  fullWidth
                  type="url"
                  required
                />
              </Grid>
              {resourceType === resourceTypes?.ASSIGNMENT && (
                <Grid item xs={12} sm={12} md={12}>
                  <TextField
                    fullWidth
                    type="date"
                    disabled={resourceType !== resourceTypes?.ASSIGNMENT}
                    helperText="Due Date"
                    size="small"
                    required
                    onChange={handleAssignmentDueDate}
                    value={dueDate}
                  />
                </Grid>
              )}
            </Grid>
          )}

          <Container sx={{ textAlign: "end" }}>
            <Button onClick={handleReset}>Reset</Button>
            <Button type="submit" variant="contained">
              Edit
            </Button>
          </Container>
        </DialogContent>
      </form>
    </Dialog>
  );
};

export default EditResourcePopUp;
